export const Setting = {
  ClientVersionMin: 'Minimum version of the client',
  MaintenanceInProgress: 'System maintenance',
  SettingUpdated: 'Setting updated',
  Title: 'Setting',
};
